'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.selectLatLngForLocations = selectLatLngForLocations;

var _utils = require('shared/redux/middlewares/geocoding/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPosition = function getPosition(_ref, geocodedLocations) {
  var lat = _ref.lat,
      lng = _ref.lng;

  if (lat) {
    return {
      lat: parseFloat('' + lat),
      lng: parseFloat('' + lng)
    };
  }

  return geocodedLocations;
};

function selectLatLngForLocations(state, locations) {
  return locations.map(function (location) {
    var formattedAddress = (0, _utils.formatAddressKey)(location.address);
    var position = getPosition(location, state.data.geocodedLocations[formattedAddress]);

    return (0, _extends3.default)({}, location, {
      position: position,
      geocodedLocations: state.data.geocodedLocations
    });
  });
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/Locations/selectors.js
// module id = 1222
// module chunks = 0